module.exports = __webpack_public_path__ + "019b81c55bbeab5a0f7076d893628985.png";